import React from 'react';
import { useAppConfig } from '../AppConfig';
import { computeMobileFiltersOpen } from '../components/filters/mobile-filters/MobileFiltersState';
import { useMobileFilters } from '../components/filters/mobile-filters/MobileFiltersStore';
import { useLayout } from '../components/results/layout/LayoutStore';
import { useSearchParams } from '../data/SearchParamsStore';
import { useLocationParamsCookieState } from '../data/LocationParamsCookieState';

type AppStateProviderProps = {
    children?: React.ReactNode;
};

export function AppStateProvider(props: AppStateProviderProps) {
    const { children } = props;

    useInitStores();
    useLocationParamsCookieState();

    return children;
}

function useInitStores() {
    const { initialLayout, initialSearchParams, isProbablyMobile } =
        useAppConfig();

    const { setIsMobileFiltersOpen } = useMobileFilters();
    const { setLayout } = useLayout();
    const { setSearchParams } = useSearchParams();

    const isInitialized = React.useRef(false);

    if (!isInitialized.current) {
        isInitialized.current = true;
        setIsMobileFiltersOpen(computeMobileFiltersOpen(isProbablyMobile));
        setLayout(initialLayout);
        setSearchParams(initialSearchParams);
    }
}
